<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is {{ websiteName }} Downloader?</h3>
            <p>
                {{ websiteName }} Downloader is a free Chrome extension that allows you to download videos from {{ websiteName }} for offline viewing. Save your favorite content directly to your device in original quality.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does {{ websiteName }} Downloader work?</h3>
            <p>
                Our {{ websiteName }} video downloader uses a Chrome browser extension to detect and extract video files. Simply copy the video URL, paste it into the downloader interface, and the extension will find the downloadable media for you.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is {{ websiteName }} Downloader free to use?</h3>
            <p>
                Yes, {{ websiteName }} Downloader is completely free to use. There are no hidden fees, subscription plans, or usage limits. Simply install the Chrome extension and start downloading immediately.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">What video quality can I download?</h3>
            <p>
                You can download {{ websiteName }} videos in their original quality, including HD and Full HD resolutions when available. The downloader preserves the video quality as it was uploaded to the site.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {
    props: {
        websiteName: {
            type: String,
            required: true
        }
    }
}
</script>

<style>

</style>
